import { render, staticRenderFns } from "./Documentacao.vue?vue&type=template&id=6f0777aa&scoped=true"
import script from "./Documentacao.script.js?vue&type=script&lang=js&external"
export * from "./Documentacao.script.js?vue&type=script&lang=js&external"
import style0 from "./Documentacao.css?vue&type=style&index=0&id=6f0777aa&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0777aa",
  null
  
)

export default component.exports